export class LightListModel {
  public FolderId: number;
  public ListId: number;
  public ListName: string;
  public ListType : number;

  constructor(init: any) {
    this.FolderId = init.FolderId;
    this.ListId = init.ListId;
    this.ListName = init.ListName;
    this.ListType = init.ListType;
  }
}
